import { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useLoggedIn } from 'bv-hooks';
import { t } from 'bv-i18n';

const { ModalHelper } = window;

export default () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const loggedIn = useLoggedIn();
  const history = useHistory();

  useEffect(() => {
    if (queryParams.get('show_session_expired_message')) {
      queryParams.delete('show_session_expired_message');
      history.replace({
        search: queryParams.toString(),
      });

      if (!loggedIn) {
        ModalHelper.showWarningMessage({
          title: t('session_expired'),
          iconClosable: true,
          dataLayer: {
            error_title: t('session_expired'),
            error_message: t('session_expired'),
            error_key: 'session_expired',
            error_code: 'W0x005',
          },
        });
      }
    }
  }, [location.search, loggedIn]);
};
